<template>
  <div class="measurements-page">
    <p-container>
      <p-progress-linear v-if="isLoading" :indeterminate="true" color="interaction" height="10">
      </p-progress-linear>
      <div v-if="!isLoading">
        <!-- Title -->
        <h2 class="mb-4">
          {{ $t('navigation.sensors.measurements.name') }}
        </h2>
        <p-row>
          <!-- Search Field -->
          <p-col xs12 md6 lg2>
            <p-text-field v-model="page.sensorMeasurementsDataSource.filter.searchCriteria" clearable :label="$t('core.app.search')" context-icon="search" @input="page.refreshMeasurements()"></p-text-field>
          </p-col>
          <!-- Select Fields -->
          <p-col xs12 md6 lg2>
            <p-select
              v-model="page.sensorMeasurementsDataSource.filter.selectedCustomer"
              clearable
              :label="$t('page.measurements.select.customers')"
              :items="page.customersList"
              @input="page.refreshMeasurements()"
            ></p-select>
          </p-col>
          <p-col xs12 md6 lg2>
            <p-select
              v-model="page.sensorMeasurementsDataSource.filter.selectedProject"
              clearable
              :label="$t('page.measurements.select.projects')"
              :items="page.projectsList"
              @input="page.refreshMeasurements()"
            ></p-select>
          </p-col>
          <p-col xs12 md6 lg2>
            <p-select
              v-model="page.sensorMeasurementsDataSource.filter.selectedSensorId"
              clearable
              :label="$t('page.measurements.select.sensorIds')"
              :items="page.sensorIdsList"
              @input="page.refreshMeasurements()"
            ></p-select>
          </p-col>
          <p-col xs12 md6 lg2>
            <p-select
              v-model="page.sensorMeasurementsDataSource.filter.selectedSensorTyp"
              clearable
              :label="$t('page.measurements.select.sensorTypes')"
              :items="page.sensorTypesList"
              @input="page.refreshMeasurements()"
            ></p-select>
          </p-col>
          <p-col xs12 md6 lg2>
            <p-select
              v-model="page.sensorMeasurementsDataSource.filter.selectedSensorConfig"
              clearable
              :label="$t('page.measurements.select.sensorConfigs')"
              :items="page.sensorConfigsList"
              @input="page.refreshMeasurements()"
            ></p-select>
          </p-col>
        </p-row>
        <p-row>
          <!-- Time Fields -->
          <p-col xs12 md6 lg2>
            <p-date-time-field
              v-model="page.sensorMeasurementsDataSource.filter.from"
              :label="$t('core.page.requestForm.filter.from')"
              @input="page.refreshMeasurements()"
            >
            </p-date-time-field>
          </p-col>
          <p-col xs12 md6 lg2>
            <p-date-time-field
              v-model="page.sensorMeasurementsDataSource.filter.until"
              :label="$t('core.page.requestForm.filter.until')"
              @input="page.refreshMeasurements()"
            >
            </p-date-time-field>
          </p-col>
        </p-row>
        <p-list-view
          ref="sensorMeasurementsList"
          v-model="page.sensorMeasurementsList"
          :pagination.sync="page.sensorMeasurementsDataSource.paging"
          :columns="page.measurementsColumns"
        >
          <template slot="table-actions">
            <!-- Refresh Button -->
            <p-button @click="page.refreshMeasurements()">
              <p-icon>refresh</p-icon>
            </p-button>
            <!-- Excel ausdruck Button -->
            <div v-if="page.sensorMeasurementsDataSource.data">
              <p-button :disabled="isLoading || page.sensorMeasurementsDataSource.data.items.length < 1" :loading="page.isLoadingExcel" @click="page.downloadExcel()">
                {{ $t('page.measurements.button.downloadExcel') }}
              </p-button>
            </div>
          </template>
        </p-list-view>
      </div>
    </p-container>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import MeasurementsPage from './measurements.vue.model';

  export default Vue.extend({
    name: 'Measurements',
    role: ['Admin', 'Hostadmin'],
    auth: true,
    data: () => ({
      page: new MeasurementsPage(),
      isLoading: true,
    }),
    beforeMount() {
      this.isLoading = true;
    },
    mounted() {
      this.page.initialize();
      this.isLoading = false;
    },
  });
</script>
